import { useEffect } from 'react'
import { loadMarketingTrackers } from '../utils/marketingAnalytics'

/** Load the marketing trackers (HubSpot, RudderStack) on a public page. Idempotent per page load. */
export function useMarketingTrackers(): void {
  useEffect(() => {
    loadMarketingTrackers()
  }, [])
}
